// lib/types/index.ts
// Auction Engine v2.0 - SSOT Barrel Export
// Version: 2.0
// Last Updated: 2025-01-28

// Vercel 빌드 환경 호환성을 위해 절대 경로 사용
export * from "@/lib/core/types/property";
export * from "@/lib/core/types/valuation";
export * from "@/lib/core/types/rights";
export * from "@/lib/core/types/cost";
export * from "@/lib/core/types/profit";
export * from "@/lib/core/types/courtdocs";
export * from "@/lib/core/types/result";
export * from "@/lib/core/types/simulation";
export * from "@/lib/core/types/crawling";
export * from "@/lib/core/types/real-auction";
export * from "@/lib/core/types/analysis-log";
export * from "@/lib/core/types/auction-filter";
export * from "@/lib/core/types/market-price";

// Explicit re-exports for commonly used types (to ensure TypeScript resolution)
export {
  DifficultyMode,
  PropertyCategory,
  PropertyType,
} from "@/lib/core/types/property";
export type { PropertySeed, Property } from "@/lib/core/types/property";
export type { AllocationRow, AllocationTable } from "@/lib/core/types/rights";
export type {
  RawCrawlingData,
  NormalizedCrawlingData,
  PhoneInfo,
  AddressInfo,
  ProgressCode,
  SuspensionCode,
  CourtInfo,
  FinancialsInfo,
  CodesInfo,
  UserRightsInput,
} from "@/lib/core/types/crawling";
export {
  CRAWLING_PROPERTY_TYPE_MAP,
  mapCrawlingPropertyType,
} from "@/lib/core/types/crawling";
export type {
  AuctionDBResult,
  RealAuction,
  AuctionInsights,
} from "@/lib/core/types/real-auction";
export type {
  AnalysisLogUserInputs,
  AnalysisLogResultSnapshot,
  AnalysisLog,
  AnalysisLogInsert,
} from "@/lib/core/types/analysis-log";

// Simulation types (SSOT re-export)
export { SimulationPurpose } from "@/lib/core/types/simulation";
export type { SimulationOptions } from "@/lib/core/types/simulation";

// Policy types (SSOT re-export)
export type { Policy, PolicyOverrides } from "@/lib/core/policy/policy";

// Law types (SSOT re-export)
export * from "@/lib/core/types/law";
export type {
  Statute,
  Precedent,
  LegalJudgment,
  LegalQuery,
  LegalSearchResult,
} from "@/lib/core/types/law";
